// Manager-bucket KB gap inbox reminder — §5.2 / SC-5.
//
// Surfaces open `kb_gap_items` count from `/api/kb/admin/getGaps`
// (countOnly). R3: renders `null` when count is zero or unknown.

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import { formatKbGapsBodyLine } from "./managerDockCopy";

export type ActivityDockKbGapsSectionProps = {
  kbGapOpenCount: number | null;
  currentMode?: PrimaryMode | null;
  onOpenKbGapInbox?: () => void;
};

export function ActivityDockKbGapsSection({
  kbGapOpenCount,
  currentMode = null,
  onOpenKbGapInbox,
}: ActivityDockKbGapsSectionProps) {
  if (kbGapOpenCount == null || kbGapOpenCount <= 0) return null;

  const bodyLine = formatKbGapsBodyLine(kbGapOpenCount, currentMode);

  return (
    <section
      aria-label="KB gap inbox reminder"
      className="mt-3 rounded-2xl border border-amber-300 bg-amber-50 px-3 py-3 text-left text-xs text-amber-900 dark:border-amber-700 dark:bg-amber-950/35 dark:text-amber-100"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide opacity-80">
            KB gaps
          </div>
          <p className="mt-1 text-[12px] leading-snug">{bodyLine}</p>
        </div>
        {onOpenKbGapInbox ? (
          <button
            type="button"
            onClick={onOpenKbGapInbox}
            className="shrink-0 rounded-lg bg-amber-700 px-2.5 py-1.5 text-[11px] font-semibold text-white hover:bg-amber-800 dark:bg-amber-600 dark:hover:bg-amber-500"
          >
            Review gaps
          </button>
        ) : null}
      </div>
    </section>
  );
}
